module.exports = __webpack_public_path__ + "img/p2-62.ca064081.png";